import React from 'react';
import { Alert, Box, Typography } from '@mui/material';
import Dopamenu from '../components/Dopamenu';
import PageMetadata from '../components/PageMetadata';
import PomodoroTimer from '../components/PomodoroTimer';
import { toolTextSx } from '../components/ToolCard';
import { useFocusTools } from '../contexts/FocusToolsContext';

const DESCRIPTION = 'Use a free Pomodoro timer with your own dopamenu. Set a focus time, pop out the timer, and get a random reward. Saved in your browser. No account needed.';
const URL = 'https://dopatize.com/tools/pomodoro';
const SCHEMA = { '@context': 'https://schema.org', '@type': 'WebApplication', name: 'Dopatize Pomodoro Timer and Dopamenu',
  description: DESCRIPTION, url: URL, applicationCategory: 'LifestyleApplication', operatingSystem: 'Any', isAccessibleForFree: true };

export default function PomodoroTools() {
  const { state, act, storageUnavailable } = useFocusTools();
  return (
    <>
      <PageMetadata title="Free Pomodoro Timer & Dopamenu | Dopatize" description={DESCRIPTION} url={URL} structuredData={SCHEMA} />
      <Typography component="h1" sx={{ fontSize: { xs: '1.2rem', sm: '1.7rem' }, lineHeight: 1.9, textAlign: 'center', m: 0 }}>Pomodoro timer & dopamenu</Typography>
      <Typography sx={{ ...toolTextSx, textAlign: 'center', mt: 2, mb: 4 }}>Focus, then enjoy a reward.</Typography>
      {storageUnavailable && <Alert severity="info" sx={{ mb: 3, '& .MuiAlert-message': toolTextSx }}>
        This browser can’t save tool data right now. You can still use the tools, but your menu may disappear when you leave.
      </Alert>}
      <Box sx={{ display: 'grid', gridTemplateColumns: { xs: 'minmax(0, 1fr)', md: 'repeat(2, minmax(0, 1fr))' }, alignItems: 'start', gap: 3 }}>
        <PomodoroTimer />
        <Dopamenu rewards={state.rewards} onAdd={(reward) => act('addReward', { reward })} onRemove={(reward) => act('removeReward', { reward })}
          onImport={(rewards) => act('importRewards', { rewards })} />
      </Box>
      <Typography sx={{ ...toolTextSx, color: 'text.primary', mt: 4 }}>Saved on this device.</Typography>
      <Box component="details" sx={{ mt: 3, ...toolTextSx }}>
        <Box component="summary" sx={{ cursor: 'pointer', color: 'secondary.main' }}>How it works</Box>
        <Typography sx={{ ...toolTextSx, mt: 2, maxWidth: 800 }}>
          Set a Pomodoro focus time and add things you enjoy to your dopamenu. When time is up, one reward is picked for you.
          Pop the timer out to keep it visible while you use other tabs or apps. Keep the original Dopatize tab open;
          closing it also closes the pop-out. Sleeping browsers can delay alerts, but your saved finish time is kept.
        </Typography>
      </Box>
    </>
  );
}
